<mat-dialog-content class="options-dialog-content">
  <mat-list role="list" class="options-dialog-content-list">
    @for(option of options; track option.value) {
      <mat-list-item class="option-dialog-item" [class.selected]="option.selected" (click)="selectOption(option)">
        <div matListItemTitle>
          @if (multiple) {
            <mat-checkbox [checked]="option.selected"></mat-checkbox>
          }{{option.label}}
        </div>
      </mat-list-item>
    }
  </mat-list>
</mat-dialog-content>
  <mat-dialog-actions class="options-dialog-actions">
    <div class="action" (click)="closeDialog()"><mat-icon aria-hidden="false" aria-label="close dialog" fontIcon="close"></mat-icon></div>
    @if (multiple) {
      <div class="action" (click)="closeDialog()"><mat-icon aria-hidden="false" aria-label="select option" fontIcon="check"></mat-icon></div>
    }
  </mat-dialog-actions>
